// src/app/modules/Visitors/pages/components/BlacklistModal.jsx
import React, { useState,  useRef, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as actions from '../../../Dashbord/_redux/dashboard/Actions';
import { X, Ban, Calendar } from 'lucide-react';
import './BlacklistModal.scss';

export function BlacklistModal({ show, onHide, profileId, organizationId, onSuccess }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    reason: '',
    severity: 'medium',
    scope: 'organization',
    expires_at: '',
  });

  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;
    
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Reset form when modal closes
  useEffect(() => {
    if (!show) {
      setFormData({
        reason: '',
        severity: 'medium',
        scope: 'organization',
        expires_at: '',
      });
      setLoading(false);
    }
  }, [show]);

  function handleChange(e) {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (!isMountedRef.current) return;
    
    setLoading(true);

    try {
      const body = {
        ...formData,
        organization_id: organizationId,
        // profile_id: profileId,
      };
      
      if (!formData.expires_at) {
        delete body.expires_at;
      }

      await dispatch(actions.addData('blacklist_visitor', body, profileId));
      
      if (isMountedRef.current) {
        setFormData({
          reason: '',
          severity: 'medium',
          scope: 'organization',
          expires_at: '',
        });
        onHide();
        if (onSuccess) onSuccess();
      }
    } catch (error) {
      console.error('Error blacklisting visitor:', error);
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  }


  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered 
      size="md"
      className="blacklist-modal"
    >
      <div className="blacklist-modal-content">
        <div className="modal-header-custom">
          <h3>Add to Blacklist</h3>
          <button className="btn-close-custom" onClick={onHide} disabled={loading}>
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body-custom">
            <div className="blacklist-icon-wrapper">
              <div className="blacklist-icon">
                <Ban size={32} />
              </div>
            </div>

            <h4 className="text-center mb-3">Blacklist Visitor</h4>
            <p className="text-muted text-center mb-4">
              This visitor will be denied access and flagged as a security risk.
            </p>

            <div className="form-group">
              <label>Reason for Blacklisting *</label>
              <textarea
                name="reason"
                className="form-control"
                rows="3"
                value={formData.reason}
                onChange={handleChange}
                placeholder="Enter the reason for blacklisting..."
                required
              />
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Severity</label>
                  <select
                    name="severity"
                    className="form-control"
                    value={formData.severity}
                    onChange={handleChange}
                  >
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                    <option value="critical">Critical</option>
                  </select>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-group">
                  <label>Scope</label>
                  <select
                    name="scope"
                    className="form-control"
                    value={formData.scope}
                    onChange={handleChange}
                  >
                    <option value="organization">This Organization</option>
                    <option value="network">Entire Network</option>
                  </select>
                </div>
              </div>
            </div>

            <div className="form-group">
              <label>
                <Calendar size={16} className="mr-2" />
                Expiration Date (Optional)
              </label>
              <input
                type="date"
                name="expires_at"
                className="form-control"
                value={formData.expires_at}
                onChange={handleChange}
                min={new Date().toISOString().split('T')[0]}
              />
              <small className="form-text text-muted">
                Leave empty for permanent blacklist
              </small>
            </div>

            <div className="alert alert-danger">
              <strong>Warning:</strong> This action will immediately prevent this visitor from accessing your organization.
            </div>
          </div>

          <div className="modal-footer-custom">
            <button 
              type="button" 
              className="btn-cancel" 
              onClick={onHide}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="btn-blacklist" 
              disabled={loading || !formData.reason}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Adding...
                </>
              ) : (
                <>
                  <Ban size={16} />
                  Add to Blacklist
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
}